import moment from 'moment';
import printJS from 'print-js';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PostingsApi from '../../../API/shipment/postings-api';
import ShipmentWorkApi from '../../../API/shipment/work-api';
import { addShipmentPostings, changeShipmentPostingMany } from '../../../actions/postings';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { Text } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS, WAREHOUSES } from '../../../constans';
import PostingLine from './PostingLine';
import styles from './styles.module.scss';

const SHOPS = {
  Ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  Yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  Wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  Megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];;

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
];

let abortController = new AbortController();

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];
const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];
const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const STATUSES_ORDERS_YANDEX = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];
const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

const STATUSES_ORDERS_SBER = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];
const STATUSES_ORDERS = {
  Ozon: STATUSES_ORDERS_OZON,
  Yandex: STATUSES_ORDERS_YANDEX,
  Wb: STATUSES_ORDERS_WB,
  SBER: STATUSES_ORDERS_SBER,
  'Не выбрана': [
    'Не выбран',
    'Ожидает отгрузки',
    'Доставляется',
    'Продано',
    'Прибыл на ПВЗ',
    'Не принят на CЦ',
    'Арбитраж',
    'Отменено',
    'Отменено клиентом',
    'Обнаружен брак',
  ],
};

const FILTER = {
  0: 'all',
  1: 'delivering',
  2: 'sold',
  3: 'canceled',
  4: 'canceled_return',
  5: 'not_realization',
};

function AllPostingsPage() {
  const user = useSelector((store) => store.user);
  const [market, setMarket] = useState(MARKETS_LIST[0]);

  const [postingsPrint, setPostingsPrint] = useState({});
  const [pdfFilePath, setPdfFilePath] = useState('');

  const [sklad, setSklad] = useState(SKLAD_LIST[0]);
  const [saleSchema, setSaleSchema] = useState('fbs');
  const [period, setPeriod] = useState({ start: new Date(moment().subtract(1, 'M')), end: new Date(moment().add(5, 'd')) });

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [status, changeStatus] = useState(STATUSES[0]);
  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [shop, setShop] = useState('Все');

  const { ids, byIds, map } = useSelector((store) => store.postings);
  const dispatch = useDispatch();

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const changePrintStatus = async (numbers = [], s) => {
    await ShipmentWorkApi.changePrint({ data: { postingNumbers: numbers, isPrint: s } }).then((r) => {
      const p = r.postings;
      const changeByIds = {};
      p.forEach((item) => {
        changeByIds[item.posting_number] = item;
      });
      dispatch(changeShipmentPostingMany(changeByIds));
    });
  };

  const printSticker = useCallback(
    async (order) => {
      const r = { postingNumbers: [order.posting_number] };

      let file = await ShipmentWorkApi.pickerScan({ data: { postingNumbers: [order.posting_number] } })

      printJS({
        printable: file,
        type: 'pdf',
        base64: true,
        showModal: false,
        onPrintDialogClose: () => {
          window.focus();
          setInputFocus();
        },
      });
      await changePrintStatus([order.posting_number], true);
      setInputFocus();
    },
    [pdfFilePath],
  );



  const loadData = async () => {

    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();

    await PostingsApi.getAllPostings({
      data: {
        limit: parseInt(show),
        page,
        search: search.trim(),
        providerId: provider.id,
        tab: FILTER[tab],
        shop: shop === 'Все' ? undefined : shop.toLowerCase(),
        market: market === 'Не выбрана' ? undefined : market.toLowerCase(),
        period: {
          startDate: period.start,
          endDate: period.end,
        },
        sortType: 'allorders',
        skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
        filters: {
          orderStatus: orderStatus === 'Не выбран' ? undefined : orderStatus,
          productsStatus: status === 'Не выбран' ? undefined : status,
        },
        saleSchema: saleSchema === 'Не выбрана' ? undefined : saleSchema,
      }, signal: abortController.signal
    })
      .then((res) => {
        const { postings, cardsMap = {}, count, } = res;

        setCount(count);
        const ids = postings.map((item) => item.posting_number);
        postings.forEach((item) => (byIds[item.posting_number] = item));

        dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));
      })
      .catch(e => {
      });
  };


  const loadTabs = () => {

    PostingsApi.getTabsCount({
      data: {
        pageName: 'all_postings',
        period: {
          startDate: period.start,
          endDate: period.end,
        },
        skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      }
    })
      .then((res) => {
        const { all_count = {} } = res;

        setCountStock([
          all_count.all,
          all_count.delivering,
          all_count.sold,
          all_count.canceled,
          all_count.canceled_return,
          all_count.not_realization,
        ]);
      })
      .catch(e => console.log());
  };

  useEffect(() => {
    loadTabs()
  }, []);

  useEffect(() => {
    loadData();
    setShop('Все');
  }, [tab, show, search, provider.id, market, shop, status, orderStatus, period, sklad, saleSchema]);

  const changePostingPrint = (posting_number) => {
    if (postingsPrint[posting_number]) {
      const s = postingsPrint;
      delete s[posting_number];
      setPostingsPrint({ ...s });
    } else {
      setPostingsPrint({ ...postingsPrint, [posting_number]: true });
    }

    //setPostingsPrint({ ...postingsPrint, [order_number]: !postingsPrint[order_number] });
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === "user";

  return (
    <Content>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={
              isOwner ? ['Все заказы', 'Доставляются', 'Продано', 'Отмены', 'Брак', 'Нет в реализации'] : ['Все заказы']
            }
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>
        <Input
          value={search}
          ref={inputRef}
          onBlur={(v) => setSearch(v)}
          onClickEnter={(v) => setSearch(v)}
          label="Поиск"
        />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row style={{ height: '40px' }}>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </div>

            <Select
              list={MARKETS_LIST}
              select={market}
              label="Площадка"
              onSelect={(v) => setMarket(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SHOPS[market] || []}
              select={shop}
              disabled={market === MARKETS_LIST[0]}
              label="Магазин"
              onSelect={(v) => setShop(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Статус товара"
              select={status}
              list={STATUSES}
              width="200px"
              onSelect={(v) => changeStatus(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Статус заказа"
              select={orderStatus}
              list={STATUSES_ORDERS[market]}
              width="200px"
              onSelect={(v) => changeOrderStatus(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SKLAD_LIST}
              select={sklad}
              label="Склад отгрузки"
              onSelect={(v) => setSklad(v)}
              width={'200px'}
            />
          </Row>

          <Row>
            <Select
              list={['Не выбрана', 'fbs', 'fbo', 'express']}
              select={saleSchema}
              label="Cхема отгрузки"
              onSelect={(v) => setSaleSchema(v)}
              width={'120px'}
              style={{ marginRight: '15px' }}
            />
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.start}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.end}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>

      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>Стикер</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[12]} centerText>Дата отгрузки</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>Количество</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Статус товара</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Статус заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[6]} centerText>Склад отгрузки</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[12]} centerText={true}>Схема отгрузки</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Упаковщик / время упаковки</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Cборщик / время сборки</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>Поставщик</HeaderTitle>
        </TableHeader>
        {ids.map((order) => {
          return (
            <PostingLine
              isOwner={isOwner}
              isAdmin={isAdmin}
              order={byIds[order]}
              map={map}
              key={byIds[order].posting_number}
              setInputFocus={setInputFocus}
              postingsPrint={postingsPrint}
              changePrintStatus={changePrintStatus}
              printSticker={printSticker}
            />
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
    </Content>
  );
}

export default AllPostingsPage;
